import { UiIcon } from "shared/uikit";
import { ICONS } from "shared/constants";
import { observer } from 'mobx-react';
import { IUnitValue } from 'shared/models';
import { formatValueWithUnits } from './../../../../utilities/formatValueWithUnits';
import { useDashboardDict } from 'pages/profile-dashboard/context/useDashboardDict';

import "./styles.scss";

type PPWDWidgetBonusTotalProps = {
    name?: string;
    value?: IUnitValue;
    extra?: { name: string; value: IUnitValue }[];
}

export const PPWDWidgetBonusTotal = observer(({
    name = "Всего бонусов",
    value,
    extra = [],
}: PPWDWidgetBonusTotalProps) => {
    const { units } = useDashboardDict();

    return (
        <div className="ppd-widget-bonus-total">
            <div className="ppd-widget-bonus-total__icon">
                <UiIcon icon={ICONS.BONUS_GOLD} size={ 32 }/>
            </div>
            <div className="ppd-widget-bonus-total__lines">
                <div className="ppd-widget-bonus-total__main">
                    <div className="ppd-widget-bonus-total__main-text">{name}</div>
                    <div className="ppd-widget-bonus-total__main-value">
                        {value && formatValueWithUnits(value, units) ? formatValueWithUnits(value, units) : "-"}
                    </div>
                </div>
                {extra.length > 0 && extra.map((item, index) => (
                    <div key={index} className="ppd-widget-bonus-total__extra">
                        <div className="ppd-widget-bonus-total__extra-text">{item.name || ""}</div>
                        <div className="ppd-widget-bonus-total__extra-value">
                            {item.value && formatValueWithUnits(item.value, units) ? formatValueWithUnits(item.value, units) : "-"}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
});
